import React from 'react';
import audioIcon from '../Images/icons3.png';

interface Props {
  title: string;
  onClick?: (e?: React.MouseEvent) => void;
}

/** Split "name date rest" Daily Satsang titles; plain titles stay as one string */
const parseTitle = (title: string): string[] => {
  if (!title) return [];
  const match = title.match(/^(.*?)\s+(\d{2}\/\d{2}\/\d{4})\s+(.+)$/);
  if (match) {
    return [match[1], match[2], match[3]];
  }
  return [title];
};

const titleLineStyle: React.CSSProperties = {
  fontWeight: "bold",
  color: "#4b2e2e",
  fontSize: "13px",
  lineHeight: "1.3",
  overflow: "hidden",
  textOverflow: "ellipsis",
  wordBreak: "break-word",
  margin: 0,
};

/**
 * Compact horizontal audio/pravachan card.
 * Plain titles wrap up to 3 lines; dated Daily-Satsang titles keep name/date/rest rows.
 */
const HorizontalCardForAud: React.FC<Props> = ({ title, onClick }) => {
  const logdetails: string[] = [];
  logdetails.push("action=render_audio_card");
  logdetails.push(`titleLen=${title?.length || 0}`);

  const lines = parseTitle(title);
  const isPlainTitle = lines.length === 1;
  logdetails.push(`isPlainTitle=${isPlainTitle}`);
  console.log("HorizontalCardForAud ->", logdetails.join(" | "));

  return (
    <div
      style={{
        backgroundColor: "white",
        padding: "8px",
        width: "27vw",
        // Shorter than book tiles — icon + up to 3 title lines, no large empty pad
        minHeight: "28vw",
        height: "auto",
        textAlign: "center",
        flex: "0 0 auto",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <div>
        <img src={audioIcon} height={48} width={48} alt="" />
      </div>
      {lines.length > 0 && (
        <div style={{ marginTop: "6px", width: "100%" }}>
          {isPlainTitle ? (
            <p
              style={{
                ...titleLineStyle,
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                whiteSpace: "normal",
              }}
            >
              {lines[0]}
            </p>
          ) : (
            lines.map((line, i) => (
              <div
                key={i}
                style={{
                  ...titleLineStyle,
                  // Name + date stay one line; long "rest" may use 2 lines (≈3 total)
                  ...(i === lines.length - 1
                    ? {
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical" as const,
                        whiteSpace: "normal",
                      }
                    : { whiteSpace: "nowrap" }),
                }}
              >
                {line}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default HorizontalCardForAud;
